import React, { useEffect, useState } from "react";
import { api, getRandomImage, getUserId, getUserName, handleImageError } from "../../../hooks";
import axios from "axios";
import { Link } from "react-router-dom";
import { inIframe } from "../../../utils";
import { useTranslation } from "react-i18next";
import { NoItemView } from "../../../components";

const handleImageURL = (e) => {
    e.target.src = getRandomImage();
};

const CompletedCourses = ({ completedCourses }) => {
    const { t } = useTranslation('library');
    const renderCourses = (course: any) => {
        return (
            <>
                <div className="div-block-411" key={course?.course_id}>
                    <img
                        alt=""
                        className="image-155"
                        loading="lazy"
                        onError={handleImageURL}
                        sizes="(max-width: 767px) 234px, (max-width: 991px) 295.734375px, (max-width: 1279px) 21vw, 226.5px"
                        src={getRandomImage()}
                    />
                    <div className="label c">
                        <div className="text-block-294">{t('COURSE')}</div>
                    </div>
                </div>
                <div className="item-body">
                    <div className="div-block-417">
                        <div className="div-block-461">
                            <img
                                alt=""
                                className="image-167"
                                loading="lazy"
                                sizes="100vw"
                                src="images/google.png"
                                srcSet="images/google-p-500.png 500w, images/google.png 512w"
                            />
                        </div>
                        <div className="text-block-235">{t('Google')}</div>
                        <div className="div-block-523">
                            <div className="text-block-233">{t('120 Skill Coins')}</div>
                        </div>
                    </div>
                    <div className="text-block-225">
                        {course?.course_name || ''}
                    </div>
                </div>
            </>
        );
    };

    return (
        completedCourses.map((course: any) => (
            <div
                className="item-box path_box"
                id={`w-node-_9d122df3-5436-acb4-d16f-30b76ec43f9d-27264aa9`}
            >
                {!inIframe() ? (
                    <Link
                        className="link-block-31 w-inline-block"
                        to={`/courses/${course?.course_id}`}
                    >
                        {renderCourses(course)}
                    </Link>
                ) : (
                    <a
                        className="link-block-31 w-inline-block"
                        href={`${process.env.REACT_APP_IBL_SPA_SKILLS_URL}/courses/${course?.course_id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {renderCourses(course)}
                    </a>
                )}
            </div>
        ))
    )
}

export default CompletedCourses;